import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { PureComponent } from 'react';
import { QueryPreviewTabs } from '../types.js';
import { renderTabPanelButtonId, renderTabPanelId } from '../utils/a11y.js';
import { TreeView } from './TreeView.js';
const rootProps = {
    'aria-labelledby': renderTabPanelButtonId(QueryPreviewTabs.data),
    id: renderTabPanelId(QueryPreviewTabs.data),
    role: 'tabpanel',
};
export class QueryPreviewData extends PureComponent {
    constructor() {
        super(...arguments);
        this.shouldExpandNodeInitially = (keyPath, value, layer) => {
            return layer <= 1;
        };
    }
    render() {
        const { data, isWideLayout } = this.props;
        return (_jsx(TreeView, { rootProps: rootProps, data: data, isWideLayout: isWideLayout, shouldExpandNodeInitially: this.shouldExpandNodeInitially }));
    }
}
